import { useState } from 'react'
import style from  '../../../../sass/pages/profile/profile.module.scss'
import { useTranslation } from 'react-i18next'

const IdentityDocumentTypeSelect = ({state, setState, enabled}) => {
    const {t} = useTranslation()
    const [error, setError] = useState("")

    const handleChange = (e) => {
        if(!e.target.value) {
            setState("")
            setError("")
            return
        }

        setState(e.target.value)
    }

    return (
        <div className="grid grid-cols-8 xs:grid-cols-12 items-center">
            <span className='col-span-4 text-xs text-left font-bold'>
                {t("user.inputs.identity_document_type.title")}
            </span>
            <select 
                disabled={!enabled}
                className={`${style.select} col-span-12 xs:col-span-8`} 
                onInput={handleChange}
                value={state}
            > 
                <option className="hidden" value=""></option>
                <option value="international_passport">
                    {t("user.inputs.identity_document_type.values.international_passport")}
                </option>
                <option value="ikamet_id">
                    {t("user.inputs.identity_document_type.values.ikamet_id")}
                </option>
                <option value="turkish_id">
                    {t("user.inputs.identity_document_type.values.turkish_id")}
                </option>
            </select>
            {error && <div className={`${style.error} col-span-12 text-right`}>{error}</div>}
        </div>
  )
}

export default IdentityDocumentTypeSelect